import { getAccessToken, getRefreshToken } from '@utils/localStorage';
import {
  checkAccessTokenInvalid,
  checkRefreshTokenExpired,
  debounceMoveToSignIn,
  memoizedRotateTokenViaRefreshToken,
  needSignIn
} from '@utils/tokenHandler';
import { GraphQLClient, RequestMiddleware } from 'graphql-request';
import { QueryClient } from 'react-query';

console.log(process.env);

export const reactQueryClient = new QueryClient();

const requestMiddleware: RequestMiddleware = async (request) => {
  const isAccessTokenInvalid = checkAccessTokenInvalid();
  const isRefreshTokenInvalid = checkRefreshTokenExpired();
  const refreshToken = getRefreshToken();
  const accessToken = getAccessToken();

  if (!accessToken) {
    console.debug('[Request MiddleWare] access token is not exist');
    return request;
  }

  if (!isAccessTokenInvalid) {
    console.debug('[Request MiddleWare] access token is valid');
    return request;
  }

  if (isRefreshTokenInvalid && refreshToken && needSignIn()) {
    console.debug('[Request MiddleWare] login expired');
    debounceMoveToSignIn();
  }
  if (isRefreshTokenInvalid) {
    console.debug('[Request MiddleWare] refresh token is invalid');
    return request;
  }
  graphQLClient.setHeader('Authorization', `Bearer ${accessToken}`);
  await memoizedRotateTokenViaRefreshToken(refreshToken);
  return request;
};

export const graphQLClient = new GraphQLClient(process.env.REACT_APP_GOODOC_API_URL, {
  requestMiddleware
});
